// The BellHook pools the fee quote offers.
import { M_POOL_ID, MAINNET, T_POOL, TESTNET, type ChainId } from './chain';

export interface QuotePool {
  key: string;
  label: string;
  chainId: ChainId;
  pool: string;
  /** currency0 is the quote token (USDG or mUSDG sorts below the Stock Token on both chains). */
  quote: string;
  stock: string;
}

export const QUOTE_POOLS: readonly QuotePool[] = [
  { key: 'mainnet', label: 'NVDA/USDG on mainnet 4663 (initialised, no liquidity yet)', chainId: MAINNET, pool: M_POOL_ID, quote: 'USDG', stock: 'NVDA' },
  { key: 'testnet', label: 'TSLA/mUSDG on testnet 46630 (the live demo)', chainId: TESTNET, pool: T_POOL.id, quote: 'mUSDG', stock: 'TSLA' },
];

/** USDG and mUSDG have 6 decimals; Stock Tokens have 18. */
export const QUOTE_DECIMALS = 6;
export const STOCK_DECIMALS = 18;
